import React, { useState, useEffect } from 'react';
import './modal.css'; // Reuse existing modal styles

const SnipeModal = ({ isOpen, onClose, snipeSettings, setSnipeSettings, setSnipeMode }) => {
  const [defaultEthAmount, setDefaultEthAmount] = useState(snipeSettings.defaultEthAmount || '0.1');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setDefaultEthAmount(snipeSettings.defaultEthAmount || '0.1');
      setError('');
    }
  }, [isOpen, snipeSettings.defaultEthAmount]);

  const handleSave = () => {
    const amount = parseFloat(defaultEthAmount);
    
    // Validation
    if (isNaN(amount) || amount <= 0) {
      setError('Please enter a valid ETH amount greater than 0');
      return;
    }
    
    if (amount < 0.001) {
      setError('Minimum amount is 0.001 ETH');
      return;
    }
    
    if (amount > 10) {
      setError('Maximum amount is 10 ETH for safety');
      return;
    }

    const newSettings = { defaultEthAmount: defaultEthAmount };
    setSnipeSettings(newSettings);
    localStorage.setItem('koa-snipe-settings', JSON.stringify(newSettings));
    
    console.log('🎯 Quick Buy settings saved:', newSettings);
    
    // Activate Quick Buy mode after saving settings
    if (setSnipeMode) {
      setSnipeMode(true);
      console.log('🎯 Quick Buy mode activated');
    }
    
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content snipe-modal">
        <div className="modal-header">
          <h2>🎯 Quick Buy Settings</h2>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <div className="snipe-settings">
            <p className="snipe-description">
              Set your default ETH amount for quick token purchases. 
              When Quick Buy mode is active, BUY buttons will appear on each token card.
            </p>
            
            <div className="input-group">
              <label htmlFor="ethAmount">Default ETH Amount:</label>
              <div className="input-container">
                <input
                  id="ethAmount"
                  type="number"
                  value={defaultEthAmount}
                  onChange={(e) => setDefaultEthAmount(e.target.value)}
                  placeholder="0.1"
                  step="0.001"
                  min="0.001"
                  max="10"
                  className={error ? 'error' : ''}
                />
                <span className="input-suffix">ETH</span>
              </div>
              {error && <div className="error-message">{error}</div>}
            </div>
            
            <div className="warning-box">
              ⚠️ <strong>Warning:</strong> Quick Buy mode enables one-click token purchases. 
              Make sure you understand the risks of trading new tokens.
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          <button className="btn-save" onClick={handleSave}>Save & Activate</button>
        </div>
      </div>
    </div>
  );
};

export default SnipeModal;
